/*
 * cart-dog-name.js
 * カート画面の「わんちゃんのお名前」欄を保存するための小さなカスタム要素。
 *
 * 仕組み:
 *   <cart-attribute> でラップした input（name="attributes[わんちゃんのお名前]"）が
 *   変更されたら、cart/update.js に attributes として送信して保存する。
 *   これにより、お客さんは商品ページごとではなくカートで1回だけ名前を入力すればよい。
 *
 * 既存の cart-note.js（name="note" 専用）と同じ考え方。属性用に汎用化してある。
 * keepalive: true でチェックアウトへ遷移する瞬間でも保存リクエストが飛ぶようにしている。
 */
if (!window.customElements.get("cart-attribute")) {
  class CartAttribute extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("change", this._onChange.bind(this));
    }

    _onChange(event) {
      const input = event.target;
      const name = input && input.getAttribute("name");
      // name は "attributes[キー名]" の形式のみ対象
      if (!name || name.indexOf("attributes[") !== 0 || name.slice(-1) !== "]") {
        return;
      }
      const key = name.slice("attributes[".length, -1);
      const root =
        (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

      const attributes = {};
      attributes[key] = input.value;

      fetch(root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: attributes }),
        keepalive: true,
      }).catch(function () {
        // 失敗しても購入は止めない（フェイルセーフ）
      });
    }
  }

  window.customElements.define("cart-attribute", CartAttribute);
}
